import { device } from "@helpers";
import React, { useCallback } from "react";
import styled from "styled-components";
import FormError from "./FormError";

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const Select = styled.select`
  width: 100%;
  padding-bottom: 0px;
  font-size: 16px;

  @media (min-width: ${device.laptop}) {
    margin-top: 6px;
  }
`;

const FormSelect = ({
	label,
	name,
	options,
	required,
	register,
	errors,
	clearErrors,
	placeholder,
	onChange,
}) => {
	const getErrorMessage = () => errors && errors[name] && errors[name].message;

	const clearError = useCallback(
		(e) => {
			if (errors && errors[name]) {
				clearErrors(name);
			}
		},
		[errors, name, clearErrors],
	);

	return (
		<Container>
			<label htmlFor={label} className={`${required && "required"}`}>
				{label}
			</label>
			<Select
				id={label}
				name={name}
				ref={register}
				placeholder={placeholder}
				onChange={onChange || clearError}
			>
				{options.map(({ value, label: optionLabel, disabled = false }) => (
					<option key={value} value={value} disabled={disabled}>
						{optionLabel}
					</option>
				))}
			</Select>
			<FormError>{getErrorMessage()}</FormError>
		</Container>
	);
};

export default FormSelect;
